<h4>
    Custom XML Parts in document
    <fluent-button appearance="stealth" (click)="listCustomXml()">
        <i class="fas fa-sync"></i>
    </fluent-button>
</h4>

<div style="width: 100%; flex: 1; overflow: auto">
    <wj-flex-grid #grid [itemsSource]="parts" style="height: 100%" [isReadOnly]="true" headersVisibility="Column" (dblclick)="showSelectedXmlInEditor()">
        <wj-flex-grid-column [header]="'Namespace'" [binding]="'namespaceUri'" width="*"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'ID'" [binding]="'id'"></wj-flex-grid-column>
    </wj-flex-grid>
</div>

<div class="toolbar">
    <fluent-button appearance="accent" (click)="showSelectedXmlInEditor()">Show</fluent-button>
</div>
